// const DomainUrl = "https://khazen-be-prod.khazyn.app"
// const DomainUrl = "http://127.0.0.1:8000";
// const DomainUrl = "https://system1.rotanaegypttravel.com";
// const DomainUrl = "http://109.199.112.2:9888/";

const DomainUrl = process.env.NODE_ENV === "development" ? "http://127.0.0.1:8000/": "https://system1.rotanaegypttravel.com";
export default DomainUrl;
